import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

import adminCss from './sass/adminpage.module.scss'
import themeCss from '../components/sass/theme.module.scss'

export default function AdminBreadcrumbs(props) {

  const [mainTitle, setMainTitle] = useState('')
  const [mainLink, setMainLink] = useState('')

  useEffect(() => {

    if (!props.auctionDetail) return

    switch(props.auctionDetail.Status) {
      case "CLOSED":
        setMainTitle('Archived Auctions')
        setMainLink('/admin/listarchivedauctions')
        break;
      case "PUBLIC":
        setMainTitle('Public Auctions')
        setMainLink('/admin/listpublicauctions')
        break;
      case "PREVIEW":
        setMainTitle('Preview Auctions')
        setMainLink('/admin/listpreviewauctions')
      break;
      default:
        setMainTitle()
        setMainLink()
    }
  }, [props.auctionDetail])

  if (!props.auctionDetail) return <></>
 
  return (
    <div className={adminCss['admin-auction-page-breadcrumbs']}>
      <Link className={themeCss['bold-nodecoration']} to={mainLink}> {mainTitle}</Link>
      <span> 
        &nbsp;/ {props.auctionDetail.Title}
      </span>
    </div>
  )
}